import { colors } from 'theme/tokens';

export const partnerThemes = {
  aldar: {
    key: 'aldar',
    code: '4721836',
    name: 'AlDar Exchange',
    logo: '/logo-aldar.svg',
    token: {
      colorPrimary: '#7C5CFC',
      colorSuccess: '#10B981',
      colorWarning: '#F59E0B',
      colorError: '#EF4444',
      colorInfo: '#3B82F6',
      borderRadius: 8,
      fontFamily: "'Inter'",
    },
    sider: {
      bg: '#1E1B3A',
      subBg: '#13112A',
    },
    branding: {
      primaryColor: '#7C5CFC',
      secondaryColor: '#c9a84c',
      headerBg: '#1E1B3A',
      ctaText: 'Search Flights',
      ctaColor: '#c9a84c',
      fontFamily: 'Inter',
      heroImage: 'dubai-skyline',
      showTrustBadges: true,
      showLoyaltyBanner: true,
      emailHeaderBg: '#1E1B3A',
      emailAccentColor: '#7C5CFC',
      emailLogoPosition: 'left',
      emailFontFamily: 'Inter',
      emailFooterText: 'AlDar Exchange Travel | Dubai, UAE\nIATA Accredited | Licensed by DTCM',
      emailShowSocial: true,
      emailSubjects: {
        booking_confirmation: 'Your Booking {{booking_ref}} is Confirmed',
        eticket: 'E-Ticket for {{route}} — {{booking_ref}}',
        cancellation: 'Booking {{booking_ref}} Cancellation Notice',
        payment_receipt: 'Payment Receipt — {{booking_ref}}',
        itinerary: 'Your Travel Itinerary — {{route}}',
      },
    },
    loginTheme: {
      loginName: 'AlDar Exchange',
      loginLogo: '/logo-aldar.svg',
      panelBg: '#1E1B3A',
      panelAccent: '#7C5CFC',
      panelAccentDeep: '#5A3DC7',
      accentHighlight: '#c9a84c',
      accentHighlightSoft: '#FFF8E7',
      accentHighlightMuted: '#E8D5A0',
      softAccent: '#A78BFA',
      orbColor1: '#7C5CFC',
      orbColor2: '#c9a84c',
      orbColor3: '#A78BFA',
      btnBg: '#7C5CFC',
      btnHoverBg: '#9B7DFF',
      inputFocusBorder: '#7C5CFC',
      inputHoverBorder: '#A78BFA',
      headingColor: '#1E1B3A',
      tagColor: '#7C5CFC',
      dividerColor: '#c9a84c',
    },
  },
  snoonu: {
    key: 'snoonu',
    code: '5839204',
    name: 'Snoonu',
    logo: '/logo-snoonu.svg',
    token: {
      colorPrimary: '#7C5CFC',
      colorSuccess: '#10B981',
      colorWarning: '#F59E0B',
      colorError: '#EF4444',
      colorInfo: '#3B82F6',
      borderRadius: 10,
      fontFamily: "'Inter'",
    },
    sider: {
      bg: '#1E1B3A',
      subBg: '#13112A',
    },
    branding: {
      primaryColor: '#7C5CFC',
      secondaryColor: '#F87171',
      headerBg: '#1E1B3A',
      ctaText: 'Book Now',
      ctaColor: '#7C5CFC',
      fontFamily: 'Inter',
      heroImage: 'doha-corniche',
      showTrustBadges: false,
      showLoyaltyBanner: true,
      emailHeaderBg: '#1E1B3A',
      emailAccentColor: '#7C5CFC',
      emailLogoPosition: 'center',
      emailFontFamily: 'Poppins',
      emailFooterText: 'Snoonu Travel | Doha, Qatar\nPowered by Snoonu',
      emailShowSocial: true,
      emailSubjects: {
        booking_confirmation: 'Booking Confirmed! Ref: {{booking_ref}}',
        eticket: 'Your E-Ticket — {{route}}',
        cancellation: 'Cancellation — {{booking_ref}}',
        payment_receipt: 'Payment Received — {{booking_ref}}',
        itinerary: 'Trip Itinerary: {{route}}',
      },
    },
    loginTheme: {
      loginName: 'Snoonu',
      loginLogo: '/logo-snoonu.svg',
      panelBg: '#1E1B3A',
      panelAccent: '#7C5CFC',
      panelAccentDeep: '#5A3DC7',
      accentHighlight: '#F87171',
      accentHighlightSoft: '#FEF2F2',
      accentHighlightMuted: '#FECACA',
      softAccent: '#A78BFA',
      orbColor1: '#7C5CFC',
      orbColor2: '#F87171',
      orbColor3: '#A78BFA',
      btnBg: '#7C5CFC',
      btnHoverBg: '#9B7DFF',
      inputFocusBorder: '#7C5CFC',
      inputHoverBorder: '#A78BFA',
      headingColor: '#1E1B3A',
      tagColor: '#7C5CFC',
      dividerColor: '#F87171',
    },
  },
};

export const partnerList = Object.values(partnerThemes);

export const partnerByCode = Object.fromEntries(
  partnerList.map((p) => [p.code, p.key])
);

// The login screen before a partner code is recognised: the active brand's
// (theme/brands — Zenvoya's violet by default).
export const defaultLoginTheme = {
  loginName: 'Zenvoya',
  loginLogo: null,
  ...colors.partnerLogin,
};

export function getLoginTheme(partnerId) {
  if (partnerId && partnerThemes[partnerId]?.loginTheme) {
    return partnerThemes[partnerId].loginTheme;
  }
  return defaultLoginTheme;
}
